/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/no-array-index-key */
import React, { memo, useRef, useLayoutEffect, useEffect } from 'react';

export interface SingleOTPInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  focus?: boolean;
}

function usePrevious<T>(value?: T): any {
  const ref = useRef<T>();

  // Store current value in ref
  useEffect((): any => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}

export const SingleOTPInputComponent = (props: SingleOTPInputProps): any => {
  const { focus, autoFocus,  ...rest } = props;
  const inputRef = useRef<any>(null);
  const prevFocus = usePrevious(!!focus);
  useLayoutEffect((): any => {
    if (inputRef?.current) {
      if (focus && autoFocus) {
        inputRef?.current?.focus();
      }
      if (focus && autoFocus && focus !== prevFocus) {
        inputRef.current.focus();
        inputRef.current.select();
      }
    }
  }, [autoFocus, focus, prevFocus]);

  return <input ref={inputRef} {...rest} />;
};

const SingleOTPInput = memo(SingleOTPInputComponent);
export default SingleOTPInput;
